import $ from "jquery";

import Draw, { createBox, createRegularPolygon } from "ol/interaction/Draw";
import Polygon from "ol/geom/Polygon";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

export default class SisCreator {
	constructor(map) {
		// console.log("SisCreator loaded");

		if (!map) return false;

		this.map = map;
		this.type = "Circle"; // 그리기 타입

		this.source = new VectorSource({ wrapX: false });
		this.vectorLayer = new VectorLayer({
			source: this.source,
			style: new Style({
				fill: new Fill({
					color: "rgba(255, 255, 255, 0)",
				}),
				stroke: new Stroke({
					color: "red",
					width: 3,
				}),
				image: new CircleStyle({
					radius: 7,
					fill: new Fill({
						color: "red",
					}),
				}),
			}),
			zIndex: 999,
		});

		this.draw = null;

		this.map.addLayer(this.vectorLayer);
	}

	addInteraction = () => {
		this.map.addInteraction(this.draw);
	};

	removeInteraction = () => {
		this.map.removeInteraction(this.draw);
	};

	// 포인트
	createPoint = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Point",
		});

		this.addInteraction();

		return this.draw;
	};

	// 폴리라인
	createLine = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "LineString",
		});

		this.addInteraction();

		return this.draw;
	};

	// 폴리곤
	createPolygon = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Polygon",
		});

		this.addInteraction();

		return this.draw;
	};

	// 원
	createCircle = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Circle",
		});

		this.addInteraction();

		return this.draw;
	};

	// 정삼각형
	createTriangle = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Circle",
			geometryFunction: createRegularPolygon(3),
		});

		this.addInteraction();

		return this.draw;
	};

	// 정사각형
	createSquare = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Circle",
			geometryFunction: createRegularPolygon(4),
		});

		this.addInteraction();

		return this.draw;
	};

	// 직사각형
	createBox = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Circle",
			geometryFunction: createBox(),
		});

		this.addInteraction();

		return this.draw;
	};

	// 별
	createStar = () => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Circle",
			geometryFunction: this.geometryFunction,
		});

		this.addInteraction();

		return this.draw;
	};

	geometryFunction = function (coordinates, geometry) {
		var center = coordinates[0];
		var last = coordinates[1];
		var dx = center[0] - last[0];
		var dy = center[1] - last[1];
		var radius = Math.sqrt(dx * dx + dy * dy);
		var rotation = Math.atan2(dy, dx);
		var newCoordinates = [];
		var numPoints = 12;
		for (var i = 0; i < numPoints; ++i) {
			var angle = rotation + (i * 2 * Math.PI) / numPoints;
			var fraction = i % 2 === 0 ? 1 : 0.5;
			var offsetX = radius * fraction * Math.cos(angle);
			var offsetY = radius * fraction * Math.sin(angle);
			newCoordinates.push([center[0] + offsetX, center[1] + offsetY]);
		}
		newCoordinates.push(newCoordinates[0].slice());
		if (!geometry) {
			geometry = new Polygon([newCoordinates]);
		} else {
			geometry.setCoordinates([newCoordinates]);
		}
		return geometry;
	};

	// 텍스트
	createText = (text, size, color) => {
		this.removeInteraction();

		this.draw = new Draw({
			source: this.source,
			type: "Point",
		});

		this.draw.on("drawend", (evt) => {
			const feature = evt.feature;
			const style = new Style({
				text: new Text({
					font: `${size}pt Calibri,sans-serif`,
					fill: new Fill({ color: color }),
					stroke: new Stroke({
						color: "#fff",
						width: 2,
					}),
					text: text,
				}),
			});

			feature.setStyle(style);
		});

		this.addInteraction();
	};

	stop = () => {
		this.removeInteraction();
	};

	clear = () => {
		this.source.clear();
		this.stop();
	};
}
